import { TermsOfService } from "../copy/termsOfService";

const UserAgreement = () => {
  return (
    <div
      className="p-10"
      dangerouslySetInnerHTML={{ __html: TermsOfService }}
    />
  );
};

export default UserAgreement;
